export const shadow = {
    outside: {
        100: "0.0px 2.0px 8.0px 0px rgba(0, 0, 0, 0.04)",
        200: "0.0px 4.0px 16.0px 0px rgba(0, 0, 0, 0.08)",
        300: "0.0px 8.0px 32.0px 0px rgba(0, 0, 0, 0.16)",
    },
    inside: {
        100: "0.0px 0.0px 8.0px 0px rgba(0, 0, 0, 0.04) inset",
        200: "0.0px 0.0px 16.0px 0px rgba(0, 0, 0, 0.08) inset",
        300: "0.0px 0.0px 32.0px 0px rgba(0, 0, 0, 0.16) inset",
    },
};
